export default __webpack_public_path__ + "static/media/colorado.e4a237c5.jpg";